import React, {useState, useEffect} from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider, MuiThemeProvider, Tooltip} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Filter1, Today, LocationOn, } from '@material-ui/icons';
import {functions} from 'constants/index'
import { createMuiTheme } from "@material-ui/core/styles";

function DatosCiudadano(props) {   
    const classes = useStyles()
    const theme = createMuiTheme({
        overrides: {
          MuiTooltip: {
            tooltip: {
              fontSize: "1rem",
              color: "white",
              backgroundColor: "#205690",
              borderRadius: 10,
              padding: '1rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              textAlign: 'center'
            }
          }
        }
      });
    useEffect(() => {
        // console.log('inconsistenciasRENAP: ', props.inconsistenciasRENAP)
    },[props.datosCiudadanoTable])
    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS DEL DPI</strong> <Divider /></div>
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="CUI del DPI: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <MuiThemeProvider theme={theme}>
                        <Tooltip title={props.inconsistenciasRENAP?.objetoInconsistencia?.cui ? ('Dato modificado: '+props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.cui) : ''}>
                            <Chip variant="outlined" className={props.inconsistenciasRENAP?.objetoInconsistencia?.cui ? classes.colorChipModified : classes.colorChip}
                            label={props.inconsistenciasRENAP?.cui ? props.inconsistenciasRENAP?.cui : ''} />                                
                        </Tooltip>
                </MuiThemeProvider>
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha de emisión del DPI: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <MuiThemeProvider theme={theme}>
                        <Tooltip title={props.inconsistenciasRENAP?.objetoInconsistencia?.fechaEmisionDPI ? ('Dato modificado: '+functions.dateFormatGeneral(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.fechaEmisionDPI)) : ''}>
                            <Chip variant="outlined" className={props.inconsistenciasRENAP?.objetoInconsistencia?.fechaEmisionDPI ? classes.colorChipModified : classes.colorChip}
                            label={functions.dateFormatGeneral(props.inconsistenciasRENAP.fechaEmisionDPI ? props.inconsistenciasRENAP.fechaEmisionDPI :'')} />
                        </Tooltip>
                </MuiThemeProvider>                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="No. Serie: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <MuiThemeProvider theme={theme}>
                    <Tooltip title={props.inconsistenciasRENAP?.objetoInconsistencia?.serie ? ('Dato modificado: '+props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.serieDPI) : ''}>
                        <Chip variant="outlined" className={props.inconsistenciasRENAP?.objetoInconsistencia?.serie ? classes.colorChipModified : classes.colorChip} 
                            label={props.inconsistenciasRENAP?.serie ? props.inconsistenciasRENAP?.serie: ''} />
                    </Tooltip>
                </MuiThemeProvider>
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar de Vecindad: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <MuiThemeProvider theme={theme}>
                        <Tooltip title={(props.inconsistenciasRENAP?.objetoInconsistencia?.departamentoVecindad || props.inconsistenciasRENAP?.objetoInconsistencia?.municipioVecindad) ? ('Dato modificado: '+props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentoVecindad.name+', '+props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioVecindad.name) : ''}>
                            <Chip variant="outlined" className={(props.inconsistenciasRENAP?.objetoInconsistencia?.departamentoVecindad || props.inconsistenciasRENAP?.objetoInconsistencia?.municipioVecindad) ? classes.colorChipModified : classes.colorChip} 
                                label={(props.inconsistenciasRENAP.nombreDepartamentoVecindad ? props.inconsistenciasRENAP?.nombreDepartamentoVecindad:'')+', '+
                                (props.inconsistenciasRENAP?.nombreMunicipioVecindad ? props.inconsistenciasRENAP?.nombreMunicipioVecindad:'')}
                            />
                        </Tooltip>
                </MuiThemeProvider>                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="No. Cédula: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                label={(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.ordenCedulaRef ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.ordenCedulaRef : '')+'-'+
                (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.registroCedulaRef ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.registroCedulaRef:'')} />
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar Ext. de Cédula: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>
            </Grid >             
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                label={(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentocedula?.name ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentocedula?.name:'')+', '+
                (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioCedula?.name ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioCedula?.name:'') } />                                
            </Grid >             
        </Grid>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);